export default "__VITE_ASSET__DGElglv2__"